import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { LearnerFormTitle } from "@/features/learner/components/learner-form/LearnerFormTitle";
import { Grid } from "@mui/material";

export const LearnerOtherInfoForm: FC = () => {
  const { control } = useFormContext<TLearnerForm>();

  return (
    <InnerBox title={<LearnerFormTitle text="その他の情報" />} showDivider={false}>
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={12}>
           <FormField control={control} name="memo" label="メモ">
            <Textarea placeholder="入力してください" />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
